import AddressPro from './src'

AddressPro.install = Vue => {
  Vue.component(AddressPro.name, AddressPro)
}

export default AddressPro
